<template>
  <div>
    <custom-actions title="已预约">
      <el-form :model="searchForm" ref="searchForm2" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="plannedDate" label="计划入场日期">
          <el-date-picker v-model="searchForm2.plannedDate" placeholder="请选择计划入场日期" type="date" clearable
            format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('2')">查询</el-button>
          <el-button @click="onReset('searchForm2')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="reload">
        <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)"
          :key="index"></el-tab-pane>
      </el-tabs>
      <el-row class="mb15" v-if="ygType === 'A'">
        <el-col :span="4">最大出货量：{{ info.planNum || '0' }}</el-col>
        <el-col :span="4">
          <div style="display: flex;align-items: center;">
            <span>
              已约出货量：
            </span>
            <!-- <span class="text-view">{{ info.yyPlanNum || '0' }}</span> -->
            <el-button :disabled="!(parseFloat(info.yyPlanNum) > 0)" style="padding: 0;text-decoration: underline;"
              class="ml10" type="text" @click="loadGgList(searchForm2.plannedDate)">{{ info.yyPlanNum || '0'
              }}</el-button>
          </div>
        </el-col>
        <el-col :span="4">早餐数量：{{ info.yyMealNum2 || '0' }}</el-col>
        <el-col :span="4">午餐数量：{{ info.yyMealNum3 || '0' }}</el-col>
        <el-col :span="4">晚餐数量：{{ info.yyMealNum4 || '0' }}</el-col>
      </el-row>
      <el-table key="123" v-if="activeName === '1'" size="mini" stripe border v-loading="loading"
        :cell-style="tableCellStyle" :data="tableData2">
        <el-table-column min-width="120" align="center" fixed="left" label="时间段" prop="timeslotVal"></el-table-column>
        <el-table-column label="小车" align="center">
          <el-table-column prop="xcKh" min-width="140" show-overflow-tooltip align="center"
            label="客户"></el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="车牌号">
            <template v-slot="{ row }">
              {{ row.xcNumber || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <!-- {{ row.xcSl || '--' }} -->
              <div v-if="row.xcSl" style="display: flex;justify-content: center;align-items: center;">
                <!-- <span>{{ row.xcSl || '--' }}</span> -->
                <el-button type="text" @click="loadGgList(row.xcId)">{{ row.xcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="司机报餐">
            <template v-slot="{ row }">
              {{ isMealFormatMap.get(row.xcMe) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="140" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.xcZt) || '--' }}</span>
              <span v-if="row.xcRe === '3'">(已完成)</span>
              <span v-if="row.xcRe === '4'">(装货完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="hasComplete && row.xcAr !== '1' && row.xcNumber && ygType === 'A' && row.xcRe === '2'"
                type="text" @click="loadGgList(row.xcId, '2')">确认完成</el-button>
              <el-button v-if="hasComplete && row.xcAr !== '1' && row.xcNumber && ygType === 'B' && row.xcRe === '5'"
                type="text" @click="loadGgList(row.xcId, '2')">确认完成</el-button>
              <el-button v-if="row.xcId" type="text"
                @click="$router.push('/entryplan/detail?planId=' + row.xcId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="大车" align="center">
          <el-table-column prop="dcKh" min-width="140" show-overflow-tooltip align="center"
            label="客户"></el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="车牌号">
            <template v-slot="{ row }">
              {{ row.dcNumber || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <div v-if="row.dcSl" style="display: flex;justify-content: center;align-items: center;">
                <!-- <span>{{ row.dcSl || '--' }}</span> -->
                <el-button type="text" @click="loadGgList(row.dcId)">{{ row.dcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="司机报餐">
            <template v-slot="{ row }">
              {{ isMealFormatMap.get(row.dcMe) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="140" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.dcZt) || '--' }}</span>
              <span v-if="row.dcRe === '3'">(已完成)</span>
              <span v-if="row.dcRe === '4'">(装货完成)</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="hasComplete && row.dcAr !== '1' && row.dcNumber && ygType === 'A' && row.dcRe === '2'"
                type="text" @click="loadGgList(row.dcId, '2')">确认完成</el-button>
              <el-button v-if="hasComplete && row.dcAr !== '1' && row.dcNumber && ygType === 'B' && row.dcRe === '5'"
                type="text" @click="loadGgList(row.dcId, '2')">确认完成</el-button>
              <el-button v-if="row.dcId" type="text"
                @click="$router.push('/entryplan/detail?planId=' + row.dcId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table key="456" v-if="activeName === '2'" size="mini" stripe border v-loading="loading"
        :cell-style="tableCellStyle" :data="tableData2">
        <el-table-column min-width="120" align="center" fixed="left" label="时间段" prop="timeslotVal"></el-table-column>
        <el-table-column label="罐车" align="center">
          <el-table-column prop="gcKh" min-width="140" show-overflow-tooltip align="center"
            label="客户"></el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="车牌号">
            <template v-slot="{ row }">
              {{ row.gcNumber || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="数量">
            <template v-slot="{ row }">
              <!-- {{ row.xcSl || '--' }} -->
              <div v-if="row.gcSl" style="display: flex;justify-content: center;align-items: center;">
                <!-- <span>{{ row.xcSl || '--' }}</span> -->
                <el-button type="text" @click="loadGgList(row.gcId)">{{ row.gcSl || '--' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center" prop="" label="司机报餐">
            <template v-slot="{ row }">
              {{ isMealFormatMap.get(row.gcMe) || '--' }}
            </template>
          </el-table-column>
          <el-table-column min-width="140" align="center" prop="" label="状态">
            <template v-slot="{ row }">
              <span>{{ arrivalStatusMap.get(row.gcZt) || '--' }}</span>
              <span v-if="row.gcRe === '3'">(已完成)</span>
              <span v-if="row.gcRe === '4'">({{ygType === 'A' ? '装货完成' : '卸货完成'}})</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="hasComplete && row.gcAr !== '1' && row.gcNumber && ygType === 'A' && row.gcRe === '2'"
                type="text" @click="loadGgList(row.gcId, '2')">确认完成</el-button>
              <el-button v-if="hasComplete && row.gcAr !== '1' && row.gcNumber && ygType === 'B' && row.gcRe === '5'"
                type="text" @click="loadGgList(row.gcId, '2')">确认完成</el-button>
              <el-button v-if="row.gcId" type="text"
                @click="$router.push('/entryplan/detail?planId=' + row.gcId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-card>

    <custom-actions title="未预约" class="mt10">
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="plateNumber" label="车牌号">
          <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('1')">查询</el-button>
          <el-button @click="onReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="关联工单号" prop="orderNumber"></el-table-column>
        <el-table-column min-width="120" label="关联客户" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="plateNumber"></el-table-column>
        <el-table-column min-width="120" label="挂车号" prop="vehicleGph"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="120" label="司机手机号" prop="driverPhone"></el-table-column>
        <el-table-column min-width="120" label="司机身份证" prop="driverId"></el-table-column>
        <el-table-column min-width="120" label="车辆类型" prop="vehicleType">
          <template v-slot="{ row }">
            {{ vehicleTypeMap.get(row.vehicleType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="计划数量" prop="plannedNum">
          <template v-slot="{ row }">
            <el-button type="text" @click="loadGgList(row.planId)">{{ row.plannedNum || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="可预约时间段" prop="">
          <template v-slot="{ row }">
            {{ row.vehicleDateStart }} 至 {{ row.vehicleDateEnd || '--' }}
          </template>
        </el-table-column>

        <!-- <el-table-column min-width="120" label="计划入场日期" prop="plannedDate"></el-table-column>
        <el-table-column min-width="140" label="计划入场时间段" prop="timeslotVal"></el-table-column>
        <el-table-column min-width="120" label="预约状态" prop="reservationStatus">
          <template v-slot="{ row }">
            {{ reservationStatusMap.get(row.reservationStatus) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="到达状态" prop="arrivalStatus">
          <template v-slot="{ row }">
            {{ arrivalStatusMap.get(row.arrivalStatus) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="签到时间" prop="arrivalTime">
        </el-table-column> -->
        <el-table-column min-width="120" label="到达状态" prop="arrivalStatus">
          <template v-slot="{ row }">
            {{ arrivalStatusMap.get(row.arrivalStatus) || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button v-if="hasComplete && row.arrivalStatus > 1" type="text"
              @click="loadGgList(row.planId, '2')">确认完成</el-button>
            <el-button type="text" @click="$router.push('/entryplan/detail?planId=' + row.planId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog title="入场规格清单" :visible.sync="guigeVisible" width="800px">
      <el-table size="mini" stripe border v-loading="loading" :data="planGgList">
        <el-table-column min-width="180" label="规格名称" prop="specName"></el-table-column>
        <el-table-column min-width="100" label="规格单位" prop="unit"></el-table-column>
        <el-table-column min-width="100" label="计划数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="100" label="发货数量" prop="pickupQuantity"></el-table-column>
        <el-table-column min-width="100" label="到货数量" prop="arrivalQuantity"></el-table-column>
        <el-table-column v-if="gGviewType === '2'" min-width="100" label="操作">
          <template v-slot="{ row }">
            <el-button type="text" @click="showNumber(row)">填写数量</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" v-if="gGviewType === '2'" class="dialog-footer">
        <el-button @click="guigeVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmComplete">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="填写数量" class="global-dialog" :visible.sync="showNumberVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="formData2" :rules="rules2" ref="form2"
          label-width="120px">
          <el-row>
            <el-col :span="124">
              <el-form-item prop="pickupQuantity" label="发货数量">
                <el-input v-model="formData2.pickupQuantity" placeholder="请输入发货数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="124">
              <el-form-item prop="arrivalQuantity" label="到货数量">
                <el-input v-model="formData2.arrivalQuantity" placeholder="请输入到货数量"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNumberVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePickupQuantity">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="comfirmVisible" title="确认装货" width="500">
      <el-form class="global-form" :model="formData3" :rules="rules3" ref="form3" style="padding: 30px 40px 20px 20px;">
        <el-form-item label="附件">
          <file-upload v-model="formData3.fileList" :multiple="true" :limit="10"></file-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="comfirmVisible = false">取消</el-button>
          <el-button type="primary" @click="submitComplete">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { validNumber3 } from '@/utils/validator'
import { deepClone } from '@/utils/utils'
import { vehicleType, reservationStatus, arrivalStatus, isMealFormat, planType } from '@/utils/dict'
export default {
  name: 'EntryPlan',
  mixins: [keepAlive],

  data() {
    return {
      activeName: '1',
      planTypeMap: planType,
      realVisible: false,
      showNumberVisible: false,
      comfirmVisible: false,
      vehicleTypeMap: vehicleType,
      reservationStatusMap: reservationStatus,
      arrivalStatusMap: arrivalStatus,
      isMealFormatMap: isMealFormat,
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        plateNumber: '',
        reservationStatus: '1'
      },
      tableData2: [],
      searchForm2: {
        plannedDate: ''
      },
      info: {
        planNum: '0', // 计划产能
        yyPlanNum: '0', // 已约出货量
        yyMealNum: '0',
        yyMealNum2: '0', // 已约早餐量
        yyMealNum3: '0', // 已约午餐量
        yyMealNum4: '0' // 已约晚餐量
      },
      planGgList: [],
      guigeVisible: false,
      formData2: {
        pickupQuantity: '',
        arrivalQuantity: '',
        planQuantity: '', // 这个计划数量是用来和实际数量做对比的，提交的时候需要删除
        specId: '',
        orderId: ''
      },
      formData3: {
        fileList: []
      },
      rules3: {
        fileList: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ]
      },
      rules2: {
        pickupQuantity: [
          { required: true, message: '请输入发货数量' },
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ],
        arrivalQuantity: [
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ]
      },
      gGviewType: '1', // 1：规格清单 2：规格清单检查，这时候可以修改发货/到货数量
      currentPickupId: ''
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasComplete() {
      return this.buttonList.includes('complete')
    },
    ygType() {
      return this.$route.query.ygType
    }
  },
  watch: {
    ygType() {
      this.searchForm2.plannedDate = this.$dayjs().format('YYYY-MM-DD')
      this.searchForm.plateNumber = ''
      this.loadData()
      this.loadData2()
    }
  },
  created() {
    this.searchForm2.plannedDate = this.$dayjs().format('YYYY-MM-DD')
    this.loadData()
    this.loadData2()
    // this.initTimer()
  },
  beforeDestroy() {
    clearInterval(this._timer)
  },
  methods: {
    reload() {
      this.loadData()
      this.loadData2()
    },
    showNumber(row) {
      console.log('当前数据', row)
      this.formData2.pickupQuantity = row.pickupQuantity || ''
      this.formData2.arrivalQuantity = row.arrivalQuantity || ''
      this.formData2.planQuantity = row.planQuantity || ''
      this.formData2.orderId = row.orderId
      this.formData2.specId = row.specId
      this.showNumberVisible = true
    },
    updatePickupQuantity() {
      this.$refs.form2.validate().then(() => {
        if (Math.abs(this.formData2.planQuantity - this.formData2.pickupQuantity) > 0.5) {
          this.$confirm('计划数量和实际数量差值超过0.5, 是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const formData2 = deepClone(this.formData2)
            delete formData2.planQuantity
            this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
              ...formData2,
              pickupId: this.currentPickupId
            }).then(res => {
              this.loadGgList(this.currentPickupId, '2')
              this.showNumberVisible = false
            })
          })
        } else {
          const formData2 = deepClone(this.formData2)
          delete formData2.planQuantity
          this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
            ...formData2,
            pickupId: this.currentPickupId
          }).then(res => {
            this.loadGgList(this.currentPickupId, '2')
            this.showNumberVisible = false
          })
        }
      })
    },
    submitComplete() {
      this.$refs.form3.validate().then(() => {
        this.$axios.post(this.$apis.deliveryOrder.editCYWlVehiclePlanCc, {
          ...this.formData3,
          planId: this.currentPickupId
        }).then(res => {
          // this.loadGgList(this.currentPickupId, '2')
          this.loadData2()
          this.loadData()
          this.guigeVisible = false
          this.comfirmVisible = false
        })
      })
    },
    loadGgList(planId, gGviewType = '1') {
      this.gGviewType = gGviewType
      this.currentPickupId = planId
      return this.$axios.get(this.$apis.clyy.selectWlVehiclePlanGg, {
        planId
      }).then(res => {
        this.planGgList = res || []
        this.guigeVisible = true
      })
    },
    loadCount() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByPage, {
        dateDay: this.searchForm2.plannedDate,
        planType: this.activeName
      }).then(res => {
        if (res && res.list && res.list.length) {
          this.info = res.list[0]
        } else {
          this.info = {
            planNum: '0', // 计划产能
            yyPlanNum: '0', // 已约出货量
            yyMealNum: '0',
            yyMealNum2: '0', // 已约早餐量
            yyMealNum3: '0', // 已约午餐量
            yyMealNum4: '0' // 已约晚餐量
          }
        }
      })
    },
    initTimer() {
      this._timer = setInterval(() => {
        this.loadData2()
      }, 1000 * 30)
    },
    checkExpired(timeslotVal) {
      const data = timeslotVal.match(/\((.*?)\)(\d{2}:\d{2})~(\d{2}:\d{2})/)
      let currentTime = this.$dayjs(this.searchForm2.plannedDate + ' ' + data[3])
      if (data[1] === '次日') {
        currentTime = currentTime.add(1, 'day')
      }
      return currentTime.isBefore(this.$dayjs())
    },
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.xcNumber && row.xcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 1 && columnIndex <= 5) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
      if (row.dcNumber && row.dcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 7 && columnIndex <= 11) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
    },
    confirmComplete() {
      if (!this.planGgList.every(item => item.pickupQuantity)) {
        this.$message({
          message: '请检查规格清单，发货数量不能为空',
          type: 'warning'
        })
        return
      }
      this.formData3.fileList = []
      this.comfirmVisible = true
      // this.$confirm('确认完成, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$axios.post(this.$apis.clyy.editMwWlVehiclePlanCc, {
      //     planId: this.currentPickupId
      //   }).then(() => {
      //     this.loadData2()
      //     this.loadData()
      //   })
      // })
    },
    deleteRow(planId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.deleteDataWlVehiclePlan, {
          planId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanByPage, {
        ...this.searchForm,
        page: this.page,
        size: 10,
        planType: this.activeName,
        ygType: this.ygType
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    loadData2() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDayByList2, {
        ...this.searchForm2,
        planType: this.activeName,
        ygType: this.ygType
      }).then(res => {
        this.tableData2 = res || []
        this.loadCount()
      })
    },
    onSearch(type) {
      if (type === '1') {
        this.page = 1
        this.loadData()
      } else {
        this.loadData2()
      }
    },
    onReset(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped></style>
